import * as React from "react";
function SvgVkontaktePerson(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M27.28 20.41a21 21 0 002.23-3.8c.07-.34-.08-.52-.43-.52h-1.76a.64.64 0 00-.67.43 15.92 15.92 0 01-2.11 3.3c-.37.41-.56.54-.76.54s-.24-.14-.24-.51v-3.26c0-.46-.05-.59-.43-.59h-2.82a.31.31 0 00-.35.3c0 .43.66.53.66 1.69v2.4c0 .48 0 .67-.25.67-.6 0-2-2.08-2.84-4.44-.16-.48-.34-.62-.79-.62H15a.42.42 0 00-.44.43c0 .47.55 2.64 2.71 5.55a6.66 6.66 0 005.07 3c1 0 1.3-.17 1.3-.62v-1.5c0-.38.15-.54.36-.54s.67.08 1.66 1.06c1.18 1.13 1.26 1.6 1.9 1.6h2c.2 0 .39-.09.39-.43a4.76 4.76 0 00-1.46-2.17c-.36-.48-1-1-1.14-1.25s-.26-.42-.07-.72z" />
      <path d="M11.77 16.9a5.14 5.14 0 10-3.88 0 7.72 7.72 0 00-5.77 7.46V25h4.57v-1.29H3.44a6.43 6.43 0 0112.79 0H13V25h4.57v-.64a7.72 7.72 0 00-5.8-7.46zM6 12.14A3.86 3.86 0 119.83 16 3.86 3.86 0 016 12.14z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVkontaktePerson);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
